import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialGeneralAppState } from 'app/store/general/GeneralAppState';
import { AppMode } from 'app/store/general/AppMode';

const generalAppStateSlice = createSlice({
    name: 'general',
    initialState: initialGeneralAppState,
    reducers: {
        setAppMode: (state, action: PayloadAction<AppMode>) => {
            state.appMode = action.payload;
        },
        setMachineId: (state, action: PayloadAction<string>) => {
            state.machineId = action.payload;
        },
        setBuildVersion: (state, action: PayloadAction<string>) => {
            state.buildVersion = action.payload;
        },
    },
});

export const { setAppMode, setMachineId, setBuildVersion } =
    generalAppStateSlice.actions;

export const generalAppStateReducer = generalAppStateSlice.reducer;
